import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';
import has from 'lodash/has';
import store from '@state/store';

export const state = initialState();

function initialState() {
  const orgInfo =
    process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878'
      ? {
          name: 'Pretty Muscles CT',
          webTrainer: 'https://train.prettymuscles.com/',
          nameWebTrainer: 'prettymuscles.com',
          webClient: 'https://train.prettymuscles.com/',
          nameWebClient: 'train.prettymuscles.com',
          extraDescription: '',
        }
      : {
          name: 'Smartfitness',
          webTrainer: 'https://smartfitness.com/',
          nameWebTrainer: 'Smartfitness.com',
          webClient: 'https://app.smartfitness.com',
          nameWebClient: 'app.smartfitness.com',
          extraDescription:
            'or click "Client Login" at the top right of <a href="https://smartfitness.com/" target="_BLANK">Smartfitness.com</a>',
        };
  return {
    allClient: [],
    allClientClone: [],
    selectedClient: null,
    selectedImage: null,
    visitedClient: null,
    selectedProductItem: null,
    clientConfirmationContext: null,
    clientUpdates: [
      {
        title: 'Now Live: Trainer Created Meal Plans!',
        body: `We are excited to release Trainer created meal plans and recipes in ${orgInfo.name} FUEL. You will notice that you can now create and publish your own recipes and meal plans for your clients to access from their ${orgInfo.name} app!`,
        ctaLabel: 'Start Planning',
        ctaLink: null,
        ctaRouteName: 'mealPlans',
        img: require('@assets/images/client-updates-mealplan.jpg'),
      },
      {
        title: 'Introducing: Client Web View',
        body: `You’ve been asking for it... clients can now view the ${orgInfo.name} app on web! This includes using their mobile browser on a desktop, laptop, tablet, or even their mobile devices! To access, your client can visit <a href=${orgInfo.webClient} target="_BLANK">${orgInfo.nameWebClient}</a> ${orgInfo.extraDescription}`,
        ctaLabel: 'Check It Out',
        ctaLink: orgInfo.webTrainer,
        ctaRouteName: null,
        img: require('@assets/images/client-updates-app.jpg'),
      },
    ],
  };
}

export const getters = {
  joinedClientsProducts(state) {
    const groupedClientsProducts = [];
    if (
      state.allClient?.length > 0 &&
      store.state.auth?.currentUser?.trainer?.myProducts &&
      store.state.auth?.currentUser?.trainer?.myProducts[0]?.plans?.length > 0
    ) {
      const products = store.state.auth.currentUser.trainer.myProducts[0].plans;
      const clients = state.allClient;
      products.forEach((product) => {
        // Filter by product id in clientObj
        const groupedClients = clients.filter(
          (client) =>
            (has(client.profile, 'subscribed_plan') &&
              client.profile.subscribed_plan === product.id) ||
            (has(client.invitation, 'price_plan') &&
              client.invitation.price_plan === product.id &&
              !client.profile.subscribed_plan)
        );

        if (groupedClients.length > 0) {
          groupedClientsProducts.push({
            product: product,
            subscribers: groupedClients,
          });
        }
      });
    }
    return groupedClientsProducts;
  },
  totalEarning(state, getters) {
    let dollars = 0;
    if (
      getters.joinedClientsProducts &&
      getters.joinedClientsProducts.length > 0
    ) {
      getters.joinedClientsProducts.forEach((product) => {
        const activeSubcribers =
          product.subscribers.length > 0
            ? product.subscribers.filter((subscriber) => {
                if (
                  has(subscriber.profile, 'subscribed') &&
                  subscriber.profile.subscribed &&
                  has(subscriber.profile, 'subscribed_plan') &&
                  subscriber.profile.subscribed_plan &&
                  has(subscriber.profile, 'end_date') &&
                  subscriber.profile.end_date &&
                  has(subscriber.profile, 'end_date') &&
                  subscriber.profile.end_date
                ) {
                  return subscriber;
                }
              }).length
            : [];

        dollars =
          dollars +
          activeSubcribers * (parseInt(product.product.unit_amount) / 100);
      });
    }
    return dollars;
  },
  totalClients(state, getters) {
    let count = 0;
    if (
      getters.joinedClientsProducts &&
      getters.joinedClientsProducts.length > 0
    ) {
      getters.joinedClientsProducts.forEach((product) => {
        count += product.subscribers.length;
      });
    }
    return count;
  },
  allClientsCount(state, getters) {
    return state.allClient.length;
  },
};

export const mutations = {
  setClientConfirmationContext(state, value) {
    state.clientConfirmationContext = value;
  },
  setVisitedClient(state, value) {
    state.visitedClient = value;
  },

  setSelectedClient(state, value) {
    state.selectedClient = value;
  },
  setAllClient(state, value) {
    state.allClient = value;
  },
  setArchiveClient(state, value) {
    const client = value.client;
    const i = state.allClient.findIndex((item) => item._id === client._id);
    const clientsClone = cloneDeep(state.allClient);

    if (has(value, 'action') && value.action === 'toArchive') {
      clientsClone[i] = { ...clientsClone[i], toArchive: true };
    } else {
      clientsClone.splice(i, 1);
    }

    state.allClient = clientsClone;
  },
  setAllClientClone(state, value) {
    state.allClientClone = value;
  },
  setCreateClient(state, value) {
    state.allClient.push(value);
  },
  setUpdateClientItem(state, value) {
    const i = state.allClient.findIndex((item) => item._id === value._id);
    const clientClone = cloneDeep(state.allClient);
    clientClone[i] = value;
    state.allClient = clientClone;

    const j = state.allClientClone.findIndex((item) => item._id === value._id);
    if (j !== -1) {
      const allClientClone = cloneDeep(state.allClientClone);
      allClientClone[j] = value;
      state.allClientClone = allClientClone;
    }
  },
  setSelectedImage(state, value) {
    state.selectedImage = value;
  },
  setSelectedProductItem(state, value) {
    state.selectedProductItem = value;
  },
  setHasUnreadMessages(state, value) {
    const i = state.allClient.findIndex(
      (client) => client._id === value.client._id
    );
    if (i !== -1) {
      const clientClone = state.allClient[i];
      clientClone.hasUnreadMessages = value?.hasUnreadMessages;
      state.allClient.splice(i, 1, clientClone);
    }

    const j = state.allClientClone.findIndex(
      (client) => client._id === value.client._id
    );
    if (j !== -1) {
      const allClientClone = state.allClientClone[j];
      allClientClone.hasUnreadMessages = value?.hasUnreadMessages;
      state.allClientClone.splice(j, 1, allClientClone);
    }
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getAllClient(ctx, { trainerId }) {
    if (trainerId !== undefined) {
      const url = api.URL_GET_ALL_CLIENT.replace(':trainerID', trainerId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllClient', res.data.clients);
          ctx.commit('setAllClientClone', res.data.clients);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(`invalid params (trainerId) : (${trainerId})`);
    }
  },

  createClient(ctx, { clientObj }) {
    if (isPayloadValid(clientObj)) {
      const url = api.URL_CREATE_CLIENT.replace(
        ':trainerID',
        clientObj.trainer_id
      );

      // Minimum data check for obj
      if (
        clientObj.email !== undefined &&
        clientObj.user !== undefined &&
        clientObj.profile.firstName !== undefined &&
        clientObj.profile.lastName !== undefined &&
        clientObj.org_id !== undefined &&
        clientObj.trainer_id !== undefined
      ) {
        const payload = { client: clientObj };
        return axios
          .post(url, payload)
          .then((res) => {
            if (res && res.data && res.data.client) {
              ctx.commit('setCreateClient', res.data.client);
              return res.data;
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'clientObj must contain the following properties to be a valid creation [ email, user, firstName, lastName, org_id, trainer_id ]',
          clientObj
        );
      }
    } else {
      logError(clientObj);
    }
  },

  updateClient(ctx, { clientObj }) {
    if (isPayloadValid(clientObj)) {
      const url = api.URL_UPDATE_CLIENT.replace(
        ':clientID',
        clientObj._id
      ).replace(':trainerID', clientObj.trainer_id);

      if (clientObj && has(clientObj, 'hasUnreadMessages')) {
        delete clientObj.hasUnreadMessages;
      }

      // Minimum data check for obj
      if (
        clientObj.email !== undefined &&
        clientObj.user !== undefined &&
        clientObj.profile.firstName !== undefined &&
        clientObj.profile.lastName !== undefined &&
        clientObj.org_id !== undefined &&
        clientObj.trainer_id !== undefined
      ) {
        const payload = { client: clientObj };
        return axios
          .put(url, payload)
          .then((res) => {
            ctx.commit('setUpdateClientItem', res.data.client);
            ctx.commit('setSelectedClient', res.data.client);

            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'clientObj must contain the following properties to be a valid replacement [ email, user, firstName, lastName, org_id, trainer_id ]',
          clientObj
        );
      }
    } else {
      logError(clientObj);
    }
  },

  inviteClient(ctx, { inviteObj, type }) {
    const url =
      type === 'send'
        ? api.URL_INVITE_CLIENT.replace(
            ':clientID',
            inviteObj.client_id
          ).replace(':trainerID', inviteObj.trainer_id)
        : api.URL_RESEND_INVITE_CLIENT.replace(
            ':clientID',
            inviteObj.client_id
          ).replace(':trainerID', inviteObj.trainer_id);
    // Minimum data check for obj
    if (
      inviteObj.client_id !== undefined &&
      inviteObj.trainer_id !== undefined
    ) {
      return axios
        .put(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'inviteObj must contain the following properties to be a valid replacement [ client_id, trainer_id ]',
        inviteObj
      );
    }
  },

  getClient(ctx, { clientObj }) {
    const url = api.URL_GET_CLIENT.replace(':clientID', clientObj._id).replace(
      ':trainerID',
      clientObj.trainer_id
    );
    // Minimum data check for obj
    if (clientObj._id !== undefined && clientObj.trainer_id !== undefined) {
      return axios
        .get(url)
        .then((res) => {
          return res.data.client;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'clientObj must contain the following properties to be a valid replacement [ client_id, trainer_id ]',
        clientObj
      );
    }
  },
  archiveClient(ctx, clientObj) {
    const url = api.URL_ARCHIVE_ClIENT.replace(':clientID', clientObj._id);
    // Minimum data check for obj
    if (clientObj._id !== undefined) {
      return axios
        .put(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'clientObj must contain the following properties to be a valid replacement [ client_id ]',
        clientObj
      );
    }
  },
};

// Private Helpers

function isPayloadValid(obj) {
  // Minimum data check for payload
  return (
    obj !== undefined ||
    (obj.trainer_id !== undefined &&
      obj.org_id !== undefined &&
      obj._id !== undefined)
  );
}

function logError(clientObj) {
  console.error(
    `Invalid Params: (clientObj, trainer_id, org_id, _id) : (${clientObj}, ${clientObj.trainer_id}, ${clientObj.org_id}, ${clientObj._id})`
  );
}
